import { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import classNames from 'classnames'
import { IDropdownProps } from '@/components/Dropdown/types'
import { NavLink } from 'react-router-dom'

export const Dropdown = ({ title, items, className }: IDropdownProps) => {
  return (
    <Menu
      as="div"
      className={classNames('relative inline-block text-left', className)}
    >
      <div>
        <Menu.Button className="min-w-max inline-flex w-full justify-center gap-x-1.5 rounded-md !bg-white px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50">
          {title}
          <ChevronDownIcon
            className="-mr-1 h-5 w-5 text-gray-700"
            aria-hidden="true"
          />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 top-full z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none py-1">
          {items.map(({ label, path, onClick, className }) => (
            <Menu.Item key={label}>
              {({ active }) =>
                path ? (
                  <NavLink
                    to={path}
                    className={({ isActive }) =>
                      classNames(
                        isActive
                          ? 'bg-gray-100 text-gray-900'
                          : 'text-gray-700',
                        'block px-4 py-2 text-sm hover:bg-gray-100',
                        className,
                      )
                    }
                  >
                    {label}
                  </NavLink>
                ) : (
                  <div
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block px-4 py-2 text-sm',
                      className,
                    )}
                    onClick={onClick}
                  >
                    {label}
                  </div>
                )
              }
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
